import { Accordion } from "react-bootstrap";
import {
  CDBBtn,
  CDBCarousel,
  CDBCarouselInner,
  CDBCarouselItem,
  CDBIframe,
} from "cdbreact";
import { ReactComponent as CarouselBody } from "../../assets/image/CarouselItems.svg";
import Logo from "../../assets/images/round-logo.png";
import "./Profile.scss";
import { useTranslation } from "react-i18next";

const Soporte = ({ theme }) => {
  const [t] = useTranslation("perfil");
  const DynamicTheme = {
    backgroundColor: theme === "light" ? "#fff" : "#1a1d27",
  };
  const BlueTheme = {
    backgroundColor: theme === "light" ? "#e8f5fd" : "#1a1d27",
    border: `1px solid #a0d4fa`,
    borderRadius: 4,
  };
  return (
    <div className="d-block d-lg-flex">
      <div className="profile-first-block">
        <div className="px-30 pt-30 border" style={DynamicTheme}>
          <div className="d-flex flex-column roundBorder">
            <h5 className="mb-0">
              <b>{t("soporte.support_material")}</b>
            </h5>
            <CDBCarousel
              activeItem={1}
              length={3}
              showControls={true}
              showIndicators={true}
              className="z-depth-1"
              slide
              mobileGesture={false}
            >
              <CDBCarouselInner>
                <CDBCarouselItem itemId="1">
                  <div className="d-flex align-items-center justify-content-center">
                    <CarouselBody />
                    <CarouselBody />
                    <CarouselBody />
                  </div>
                </CDBCarouselItem>
                <CDBCarouselItem itemId="2">
                  <div className="d-flex align-items-center justify-content-between">
                    <CarouselBody />
                    <CarouselBody />
                    <CarouselBody />
                  </div>
                </CDBCarouselItem>
                <CDBCarouselItem itemId="3">
                  <div className="d-flex align-items-center justify-content-between">
                    <CarouselBody />
                    <CarouselBody />
                    <CarouselBody />
                  </div>
                </CDBCarouselItem>
              </CDBCarouselInner>
            </CDBCarousel>
          </div>
        </div>
        <div className="p-30 mt-4 border" style={DynamicTheme}>
          <div className="d-flex flex-column roundBorder">
            <h5 className="mb-30">{t("soporte.frequently_asked_questions")}</h5>
            <Accordion defaultActiveKey="0" alwaysOpen>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  {t("soporte.there_retaliation_for_filing")}
                </Accordion.Header>
                <Accordion.Body>
                  {t("soporte.submit_compaint_provided_tracking_code")}
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  {t("soporte.there_retaliation_for_filing")}
                </Accordion.Header>
                <Accordion.Body>
                  {t("soporte.submit_compaint_provided_tracking_code")}
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  {t("soporte.there_retaliation_for_filing")}
                </Accordion.Header>
                <Accordion.Body>
                  {t("soporte.submit_compaint_provided_tracking_code")}
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  {t("soporte.there_retaliation_for_filing")}
                </Accordion.Header>
                <Accordion.Body>
                  {t("soporte.submit_compaint_provided_tracking_code")}
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  {t("soporte.there_retaliation_for_filing")}
                </Accordion.Header>
                <Accordion.Body>
                  {t("soporte.submit_compaint_provided_tracking_code")}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
      <div className="profile-second-block">
        <div
          className="d-sm-flex align-items-center justify-content-between px-20 py-3"
          style={BlueTheme}
        >
          <div>
            <h6 className="font-14 mb-1">
              {t("soporte.create_support_ticket")}
            </h6>
            <small>{t("soporte.we_are_here_to_help_you")}</small>
          </div>
          <CDBBtn className="athics-btn new-ticket">
            {t("soporte.new_ticket")}
          </CDBBtn>
        </div>
        <div className="px-20 py-30 mt-20 border" style={DynamicTheme}>
          <h5 className="mb-30">{t("soporte.video_library")}</h5>
          <div className="d-flex align-items-center">
            <img src={Logo} className="mr-2" alt="logo" />
            <h6 className="m-0">{t("soporte.ethicsglobal_comunication")}</h6>
          </div>
          <div className="mt-30">
            <h6 className="mb-0">
              {t("soporte.whats_is_corporate_governance")}
            </h6>
            <small className="mb-2">
              Fusce velit enim, ullamcorper a feugiat vitae, porttitor vel
              dolor. In molestie velit a pulvinar.
            </small>
            <CDBIframe src="https://www.youtube.com/embed/xnczyP2jSR0" />
          </div>
          <div className="mt-30">
            <h6 className="mb-0">
              {t("soporte.whats_is_corporate_governance")}
            </h6>
            <small className="mb-2">
              Fusce velit enim, ullamcorper a feugiat vitae, porttitor vel
              dolor. In molestie velit a pulvinar.
            </small>
            <CDBIframe src="https://www.youtube.com/embed/xnczyP2jSR0" />
          </div>
          <div className="mt-30">
            <h6 className="mb-0">
              {t("soporte.whats_is_corporate_governance")}
            </h6>
            <small className="mb-2">
              Fusce velit enim, ullamcorper a feugiat vitae, porttitor vel
              dolor. In molestie velit a pulvinar{" "}
            </small>
            <CDBIframe src="https://www.youtube.com/embed/xnczyP2jSR0" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Soporte;
